export default "data:text/javascript;base64,aW1wb3J0IHNzbyBmcm9tICIuL3NzbyI7CgpleHBvcnQgZGVmYXVsdCB7CiAgc3NvLAp9Owo="